import { API } from 'aws-amplify';
export function getSocketChat(id)
{
	return API.get('inVcGetSocketChat', `/getChat?meetingId=${id}`);
}

export function postSocketChat(obj)
{
	return API.post('broadcastChatPost', '/createChat', { body: obj });
}

export function createBroadcastUser(body)
{
	return new Promise((resolve, reject) =>
	{
		API.post('broadcastChatPost', '/createbroadcastuser', { body })
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}

export function generatePresignedUrl(body)
{
	return new Promise((resolve, reject) =>
	{
		API.post('user', '/generatepresignedurl', { body })
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}
